import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageTaskRequestDTO } from '../model/page-task-request';
import { ExecuterAllTask } from '../model/executer-all-task';
import { AssignerTaskAvecDelai } from 'src/app/core/services/business/model/assigner-task-avec-delai';
import { ChoisirCanalCommunication } from 'src/app/contentieux/core/model/choisir-canal-communication';
import { EnregistrerPromessePaiement } from 'src/app/contentieux/core/model/enregistrer-promesse-paiement';
import { DeclasserDossier } from 'src/app/contentieux/core/model/DeclasserDossier';
import { RestructurerDossier } from 'src/app/contentieux/core/model/RestructurerDossier';

@Injectable({
  providedIn: "root"
})
export class TaskService {
  constructor(private _restClientService: RestClientService) {}

  findTask(
    workflowCategorie,
    aregulariser,
    criteria,
    filter,
    username,
    page,
    size,
    sort,
    order
  ) {
    return this._restClientService.load<PageTaskRequestDTO>(
      "task/find-current-tasks-by-user" +
        "?aregulariser=" +
        aregulariser +
        "&workflowcategorie=" +
        workflowCategorie +
        "&criteria=" +
        criteria +
        "&filter=" +
        filter +
        "&username=" +
        username +
        "&page=" +
        page +
        "&size=" +
        size+
        '&sort=' +
        sort +
        '&order=' +
        order,
    );
  }

  executerAllTask(command: ExecuterAllTask) {
    return this._restClientService.save<void>(
      "task/executer-all-task",
      command
    );
  }

  validerFormChoixCanalCommunication(command: ChoisirCanalCommunication) {
    return this._restClientService.save<void>(
      "task/valider-form-choix-canal-communication",
      command
    );
  }

  validerFormPromessePaiement(command: EnregistrerPromessePaiement) {
    return this._restClientService.save<void>(
      "task/valider-form-promesse-paiement",
      command
    );
  }

  assigner(assignerTaskAvecDelai: AssignerTaskAvecDelai) {
    return this._restClientService.save<void>(
      "task/assigner-avec-delai",
      assignerTaskAvecDelai
    );
  }

  validerFormDeclasserDossier(command: DeclasserDossier) {
    return this._restClientService.save<void>(
      "task/valider-form-declasse-dossier",
      command
    );
  }

  validerFormDossierRestructuration(command: RestructurerDossier) {
    return this._restClientService.save<void>(
      "task/valider-form-restructuration-dossier",
      command
    );
  }
}      

    